import axios from 'axios'
import { ModalTagDetails as TagDetails } from '#components'

export default {
  methods: {
    addTagDialog () {
      this.showDialog({
        title: this._('New tag'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['title', 'category'],
            handler: this.addTag
          }
        ],
        fields: [
          {
            title: this._('Title'),
            type: 'text',
            name: 'title'
          },
          {
            title: this._('Type'),
            type: 'select',
            name: 'category',
            defaultValue: this.category ? this.category : 'product',
            options: [
              {
                value: 'product',
                name: this._('Product')
              },
              {
                value: 'admin',
                name: this._('Admin')
              },
              {
                value: 'seo',
                name: this._('SEO')
              },
              {
                value: 'delivery',
                name: this._('Delivery method')
              },
              {
                value: 'order',
                name: this._('Order')
              },
            ]
          }
        ]
      })
    },
    async addTag (params) {
      let response
      let data = {
        title: params.category + ':::' + params.title
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/tags.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.editTag(response.data, params.title)
    },
    editTag (id, title, activeTab, skipState) {
      if (this.isModal) {
        this.showModal('tagdetails', TagDetails, {
          props: {
            baseDomain: this.baseDomain,
            shopId: this.shopId,
            apiKey: this.apiKey,
            component: {
              initData: {
                tagId: id,
                modal: true
              }
            }
          },
          events: {},
          handlers: {},
          width: 800
        })
      } else {
        this.EventBus.$emit('showDetailsColumn', {
          shopId: this.shopId,
          component: 'TagDetails',
          title: this._('Tag') + ' ' + id + (title ? ': ' + title : ''),
          width: 6,
          data: {
            tagId: id,
            activeTab
          },
          skipState
        })
      }
    },
  }  
}